import { useAuth } from "../contexts/AuthContext";
import { fmtMonth, fmtKyivDateTime } from "../lib/format";

/** Месяцы с данными; у незакрытого — строка «предварительно · обновлено …» по киевскому времени. */
export function MonthSelector() {
  const { t, lang, availableMonths, monthStatuses, month, setMonth } = useAuth();
  const status = monthStatuses.find(s => s.month === month);
  const prelim = status ? status.status !== "final" : true;
  return (
    <div className="px-5 py-3 bg-white border-b border-slate-200 flex-shrink-0">
      <select
        id="month-select"
        value={month}
        onChange={(e) => setMonth(e.target.value)}
        className="w-full bg-slate-50 text-slate-900 rounded-md px-3 py-2 text-sm border border-slate-200"
      >
        {[...availableMonths].reverse().map(m => <option key={m} value={m}>{fmtMonth(m, lang)}</option>)}
      </select>
      {prelim && month && (
        <div className="text-[10px] mt-1.5 text-amber-700">
          {t("month_prelim_line", { at: status?.published_at ? fmtKyivDateTime(status.published_at) : "—" })}
        </div>
      )}
    </div>
  );
}
